import type {
  CommissionRule,
  CommissionStructure,
} from "../../types/commissionStructure";

const repRule = (
  method: CommissionRule["method"] = "percent",
  value = "50",
  basis: CommissionRule["basis"] = "remaining",
): CommissionRule => ({
  label: "Sales rep commission",
  recipient: "rep",
  method,
  basis,
  value,
});
export const commissionPresets: {
  label: string;
  description: string;
  structure: CommissionStructure;
}[] = [
  {
    label: "10 / 50 / 50",
    description: "Gross retention, then split net",
    structure: {
      version: 1,
      name: "10 / 50 / 50 split",
      limit_to_profit: true,
      rules: [
        {
          label: "Company retention",
          recipient: "company",
          method: "percent",
          basis: "contract",
          value: "10",
        },
        repRule(),
      ],
    },
  },
  {
    label: "Individual rates",
    description: "Each rep’s rate × net profit",
    structure: {
      version: 1,
      name: "Individual rep rates",
      limit_to_profit: true,
      rules: [repRule("rep_rate", "0", "profit")],
    },
  },
  {
    label: "% of revenue",
    description: "Commission on the contract",
    structure: {
      version: 1,
      name: "Revenue commission",
      limit_to_profit: false,
      rules: [repRule("percent", "10", "contract")],
    },
  },
  {
    label: "Flat commission",
    description: "A fixed amount per job",
    structure: {
      version: 1,
      name: "Flat commission",
      limit_to_profit: false,
      rules: [repRule("fixed", "1000")],
    },
  },
];
